import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router, Route } from 'react-router-dom';

import App from './pages/App';
import Users from './pages/Users';
import Pacients from './pages/Pacients';
import Login from './pages/Login';
import Profesionals from './pages/Profesionals';
import Appointments from './pages/Appointments';
import Billing from './pages/Billing';
import Hospitalizations from './pages/Hospitalizations';
import Medications from './pages/Medications';
import HospitalizationClinicalHistories from './pages/HospitalizationClinicalHistories';
import PrivateRoute from './Utils/PrivateRoutes';
import PublicRoute from './Utils/PublicRoutes';
import PacientsFrequency from "./pages/PacientsFrequency";
import ProfessionalAppointments from "./pages/ProfessionalAppointments";
import BillingMedications from './pages/BillingMedications';


ReactDOM.render(
  <Router>
    <PrivateRoute exact path="/" component={App} />
    <PublicRoute exact path="/login" component={Login} />
    <PrivateRoute exact path="/users/" component={Users} />
    <PrivateRoute exact path="/pacients/" component={Pacients} />
    <PrivateRoute exact path="/pacientsfrequency/" component={PacientsFrequency} />
    <PrivateRoute exact path="/profesionals/" component={Profesionals} />
    <PrivateRoute exact path="/appointments/" component={Appointments} />
    <PrivateRoute exact path="/professional_appointments/" component={ProfessionalAppointments} />
    <PrivateRoute exact path="/billing/" component={Billing} />
    <PrivateRoute exact path="/billing/medications/" component={BillingMedications} />
    <PrivateRoute exact path="/hospitalizations/" component={Hospitalizations} />
    <PrivateRoute exact path="/medications/" component={Medications} />
    <PrivateRoute exact path="/hospitalization-clinical-histories/" component={HospitalizationClinicalHistories} />
  </Router>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
